//import './App.css';
import React, { useState, useEffect , useContext } from 'react';
import axios from 'axios'
import background from '../assets/img/bg.png';
import logo from '../assets/img/logo.jpg';
import arialFont from '../assets/fonts/Arial.ttf'
import arialBoldFont from '../assets/fonts/arial_Bold.ttf'
import {Document, Page, View, Text, Image, Font, PDFViewer, StyleSheet} from '@react-pdf/renderer';
import { cloneElement } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from '@fortawesome/fontawesome-svg-core';

Font.register({
  family: "Arial",
  src: arialFont,
});

Font.register({
  family: "ArialBold",
  src: arialBoldFont,
});

const Br = () => "\n";
const Tab = () => "\t";

const styles = StyleSheet.create({
  tableauContainerBaseTVA: {
    position: 'absolute',
    top: 617,
    left: 385,
    right: 45,
    spaceBetween: 5,
    flexDirection: 'column',
  },
  ligneBaseTVA: {
    flexDirection: 'row',
    fontSize: 9,
    fontFamily: 'Arial',
    marginBottom: 3,
  },
  colTitreBaseTVA: { left: '5', width: '60%', fontFamily: 'Arial' },
  colBaseTVA: { left: '10', width: '60%', fontFamily: 'Arial', textAlign: 'right' },
  colDeviseBaseTVA : { left: '19', width: '30%', fontFamily: 'Arial', fontSize: 9,},
    tableauContainerBaseTVA2: {
    position: 'absolute',
    top: 650,
    left: 260,
    right: 45,
    flexDirection: 'column',
  },
  ligneBaseTVA2: {
    flexDirection: 'row',
    fontSize: 9,
    fontFamily: 'Arial',
    marginBottom: 3,
  },
  colTitreBaseTVA2: { left: '5', width: '20%', fontFamily: 'Arial' },
  colBaseTVA2: { left: '5', width: '20%', fontFamily: 'Arial', textAlign: 'right' },
  tableauContainer: {
    position: 'absolute',
    top: 262,
    left: 30,
    right: 30,
    flexDirection: 'column',
  },
  ligne: {
    flexDirection: 'row',
    fontSize: 9,
    fontFamily: 'Arial',
    marginBottom: 10,
  },
  colUniteHeader: { left: '4', width: '8%', fontFamily: 'ArialBold' },
  colQteHeader: { width: '8%', fontFamily: 'ArialBold' },
  colUsHeader: { width: '8%', fontFamily: 'ArialBold' },
  colLibelleHeader: { left: '70', width: '50%', fontFamily: 'ArialBold' },
  colDelaiHeader: { left: '92', width: '14%', fontFamily: 'ArialBold' },
  colPrixHeader: { left: '90', width: '15%', fontFamily: 'ArialBold' },
  colMontantHeader: { left: '70', width: '30%', fontFamily: 'ArialBold' },
  colUnite: { left:'5', width: '8%' },
  colQte: { right : '7', width: '8%' },
  colUs: { right : '8', width: '8%' },
  colLibelle: { right : '25', width: '50%' },
  colDelai: { left : '45', width: '14%' },
  colPrix: { textAlign:'right',left : '5', width: '15%' },
  colMontant: { textAlign:'right', right : '5', width: '15%' },

  paramRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 2,
  },
  paramText: {
    color: 'gray',
    flex: 1,
    fontSize: 6,
    marginRight: 8,
  },

  container: {
    display: "flex",
    position: "absolute",
    width: "100%",
  },
  pageBackgroundContainer: {
    position: "relative",
    padding: "30",
    paddingBottom: "100",
    width: "100%",
    alignItems : "center",

  },
  imageBackground: {
    height: "100%",
    width: "100%",
  },
  imageLogo: {
    marginLeft: 105,
    marginTop: 30,
    height: "60%",
    width: "20%",
  },
  text_logo: {
    marginLeft: 95,
    marginTop: 2,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  societe: {
    marginLeft: 32,
    marginTop: 105,
    fontSize: 8,
    fontFamily: "Arial",
  },
  numero_document: {
    marginLeft: 45,
    marginTop: 140,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_numero_document: {
    marginLeft: 47,
    marginTop: 155,
    fontSize: 9,
    fontFamily: "ArialBold",
  },
  numero_compte: {
    marginLeft: 145,
    marginTop: 140,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_numero_compte: {
    marginLeft: 150,
    marginTop: 155,
    fontSize: 9,
    fontFamily: "ArialBold",
  },
  date: {
    marginLeft: 245,
    marginTop: 140,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_date: {
    marginLeft: 227,
    marginTop: 155,
    fontSize: 9,
    fontFamily: "ArialBold",
  },
  titre: {
    marginLeft: 90,
    marginTop: 175,
    fontSize: 18,
    fontFamily: "ArialBold",
  },
  affaire: {
    marginLeft: 39,
    marginTop: 240,
    fontSize: 10,
    fontFamily: "Arial",
  },
  corps_affaire: {
    marginLeft: 125,
    marginTop: 241,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  reference: {
    marginLeft: 250,
    marginTop: 240,
    fontSize: 10,
    fontFamily: "Arial",
  },
  corps_reference: {
    marginLeft: 330,
    marginTop: 241,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  page: {
    marginLeft: 520,
    marginTop: 240,
    fontSize: 10,
    fontFamily: "Arial",
  },
  qte: {
    marginLeft: 62,
    marginTop: 260,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_qte: {
    marginLeft: 52,
    marginRight: 530,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },
  us: {
    marginLeft: 95,
    marginTop: 260,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_us: {
    marginLeft: 95,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },
  code: {
    marginLeft: 203,
    marginTop: 260,
    fontSize: 9,
    fontFamily: "Arial",
  },
  delai: {
    marginLeft: 420,
    marginTop: 260,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_delai: {
    marginLeft: 409,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps: {
    marginLeft: 115,
    marginRight: 195,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },
  pb: {
    marginLeft: 465,
    marginTop: 260,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_pb: {
    marginLeft: 463,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },
  montant: {
    marginLeft: 520,
    marginTop: 260,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_montant: {
    marginLeft: 510,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },
  corps_unite: {
    marginLeft: 35,
    marginTop: 280,
    fontSize: 9,
    fontFamily: "Arial",
  },

  libelle_livraison: {
    marginLeft: 296,
    marginTop: 35,
    fontSize: 12,
    fontFamily: "Arial",
  },
  data_client: {
    marginLeft: 310,
    marginTop: 55,
    fontSize: 10,
    fontFamily: "Arial",
  },
  data_client_2: {
    marginLeft: 300,
    marginTop: 145,
    fontSize: 11,
    fontFamily: "Arial",
  },
  data_client_3: {
    marginLeft: 300,
    marginTop: 210,
    fontSize: 8,
    fontFamily: "Arial",
  },
  base: {
    marginLeft: 265,
    marginTop: 634,
    fontSize: 10,
    fontFamily: "Arial",
  },
  tva: {
    marginLeft: 265,
    marginTop: 654,
    fontSize: 9,
    fontFamily: "Arial",
  },
  tva1_bis: {
    marginLeft: 390,
    marginTop: 620,
    fontSize: 9,
    fontFamily: "Arial",
  },
  montant_ht: {
    marginLeft: 390,
    marginTop: 605,
    fontSize: 9,
    fontFamily: "Arial",
  },
  total: {
    marginLeft: 390,
    marginTop: 650,
    fontSize: 9,
    fontFamily: "ArialBold",
  },
  unite_eur_1: {
    marginLeft: 470,
    marginTop: 605,
    fontSize: 9,
    fontFamily: "Arial",
  },
  unite_eur_2: {
    marginLeft: 470,
    marginTop: 620,
    fontSize: 9,
    fontFamily: "Arial",
  },
  unite_eur_3: {
    marginLeft: 470,
    marginTop: 652,
    fontSize: 9,
    fontFamily: "Arial",
  },
  montant_1: {
    textAlign:"right",
    marginRight: 35,
    marginTop: 605,
    fontSize: 8,
    fontFamily: "ArialBold",
  },
  montant_tva_2: {
    textAlign:"right",
    marginRight: 35,
    marginTop: 620,
    fontSize: 9,
    fontFamily: "Arial",
  },
  montant_total_3: {
    textAlign:"right",
    marginRight: 35,
    marginTop: 652,
    fontSize: 8,
    fontFamily: "ArialBold",
  },
  corps_tva: {
    textAlign:"right",
    marginRight: 215,
    marginTop: 654,
    fontSize: 9,
    fontFamily: "Arial",
  },
    corps_tva_2: {
    textAlign:"right",
    marginRight: 215,
    marginTop: 670,
    fontSize: 9,
    fontFamily: "Arial",
  },
  dir: {
    marginLeft: 33,
    marginTop: 680,
    fontSize: 10,
    fontFamily: "Arial",
  },
  service: {
    marginLeft: 163,
    marginTop: 680,
    fontSize: 10,
    fontFamily: "Arial",
  },
  reglement: {
    marginLeft: 270,
    marginTop: 692,
    fontSize: 10,
    fontFamily: "Arial",
  },
  VISA1: {
    marginLeft: 33,
    marginTop: 715,
    fontSize: 10,
    fontFamily: "Arial",
  },
  VISA2: {
    marginLeft: 165,
    marginTop: 715,
    fontSize: 10,
    fontFamily: "Arial",
  },
  banque: {
    marginLeft: 130,
    marginTop: 765,
    fontSize: 7,
    fontFamily: "ArialBold",
  }
});

function App() {
  const location = useLocation();
  const soc = location.state?.soc || "";
  const numero = location.state?.numero || "";
  return (
    <div className="App">
      <PDFViewer height="750" width="100%">
        <MyPDF 
        societe={soc}
        numerodocument={numero}/>
      </PDFViewer>
    </div>
  );
}

const ARTICLES_PAR_PAGE = 9; // 9 articles max sur la première page

const MyPDF = (params) => {

  const soc = params.societe;
  const numero = params.numerodocument;

  const [enteteDocument, setEnteteDocument] = useState({});
  const [baseTVA, setBaseTVA] = useState({});
  const [montantTVA, setMontantTVA] = useState({});
  const [detailsTVA, setDetailsTVA] = useState({});
  const [lignesDocument, setLignesDocument] = useState([]);
  const [detailsEtab, setDetailsEtab] = useState({});
  const [detailsClient, setDetailsClient] = useState({});
  const [montantTTC, setMontantTTC] = useState(0);
  const [montantHT, setMontantHT] = useState(0);
  const [distance, setDistance] = useState(0);
  const [vehicule, setVehicule] = useState(0);
  const [tauxhoraire, setTauxhoraire] = useState(0);
  const [trajet, setTrajet] = useState(0);
  const [temps, setTemps] = useState(0);
  const [produits, setProduits] = useState(0);
  const [materiels, setMateriels] = useState(0);
  const [montantTransport, setMontantTransport] = useState(0);
  const [montantProduitMateriel,setMontantProduitMateriel] = useState(0);

  const fetchDocument = async (soc, numero) => {
    try {
      const response = await axios.get(`/devis/${soc}/${numero}`);
  
      setEnteteDocument(response.data["entete"]); 
      setLignesDocument(response.data["lignes"]); 
  
    } catch (error) {
      console.error("Erreur lors de la récupération des informations du document :", error);
    }
  };

  useEffect(() => {
    if (soc && numero) {  
      fetchDocument(soc, numero);
    }
  }, [soc, numero]); 

  const fetchEtab = async (soc) => {
    try {
      const response = await axios.get(`/etab_by_soc?soc=${soc}`);
      setDetailsEtab(response.data[0]);
    } catch (error) {
      console.error("Erreur lors de la récupération des informations clients :", error);
    }
  };
  
  useEffect(() => {
    if (soc) {
      fetchEtab(soc);
    }
  }, [soc]);

  const fetchClientEntete = async (soc, numero) => {
    try {
      const response = await axios.get(`/client_by_number?soc=${soc}&numero=${numero}`);
      setDetailsClient(response.data[0]);
    } catch (error) {
      console.error("Erreur lors de la récupération des informations clients :", error);
    }
  };
  
  useEffect(() => {
    if (enteteDocument && enteteDocument.compte) {
      fetchClientEntete(soc, enteteDocument.compte);

      setDistance(parseFloat(enteteDocument.distance));
      setVehicule(parseFloat(enteteDocument.vehicule));
      setTrajet(parseFloat(enteteDocument.trajet));
      setTauxhoraire(parseFloat(enteteDocument.tauxhoraire));
      setTemps(parseFloat(enteteDocument.temps));
      setProduits(parseFloat(enteteDocument.materiel));
      setMateriels(parseFloat(enteteDocument.produit));

    }
  }, [enteteDocument, soc]);

  useEffect(() => {

    if (lignesDocument.length != 0) {
      
      const data = {};

      lignesDocument.forEach(ligne => {
            data[ligne.ligne] = {
              taux: ligne.tva,
              base: ligne.valeur,
              montant_ttc: parseFloat(parseFloat(ligne.valeur)*(1+(parseFloat(ligne.tva)/100))).toFixed(2),
            };
          });

      var transport = distance * vehicule * (tauxhoraire / 60) * temps + trajet;
      var produitmateriel = parseFloat(produits + materiels);

      data[lignesDocument.length] = {
              taux: "0.00",
              base: transport,
              montant_ttc: transport*(1+(parseFloat(0)/100)).toFixed(2)
      }

      data[lignesDocument.length+1] = {
              taux: "0.00",
              base: produitmateriel,
              montant_ttc: produitmateriel*(1+(parseFloat(0)/100)).toFixed(2)
      }
        
      setDetailsTVA(data);

      let montant_total = 0;
      let montant_ht = 0

      let splitBaseTVA = {};
      let splitMontantTVA = {};

      for(let i=0;i<Object.keys(data).length;i++) {

        if (!splitBaseTVA[data[i].taux] && !splitMontantTVA[data[i].taux]) {
          splitBaseTVA[data[i].taux] = parseFloat(data[i].base);
          splitMontantTVA[data[i].taux] = parseFloat(data[i].base)*(parseFloat(data[i].taux)/100);

        }
        else {
          splitBaseTVA[data[i].taux] += parseFloat(data[i].base);
          splitMontantTVA[data[i].taux] += parseFloat(data[i].base)*(parseFloat(data[i].taux)/100);
        } 

        montant_total += parseFloat(data[i].montant_ttc);
        montant_ht += parseFloat(data[i].base);
      }

      setMontantTransport(transport);
      setMontantProduitMateriel(produitmateriel);
      setMontantTTC(montant_total.toFixed(2));
      setMontantHT(montant_ht.toFixed(2));
      setBaseTVA(splitBaseTVA);
      setMontantTVA(splitMontantTVA);
    }
  }, [lignesDocument, soc]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const adresse_client = (data) => {

    var adresse = `${data.nom}\n${data.rue1}\n${data.rue2}\n${data.cp} ${data.ville}\n${data.pays}`

      if (!data.rue2) {
        adresse = `${data.nom}\n${data.rue1}\n${data.cp} ${data.ville}\n${data.pays}`
      }

      return adresse;
  }

  const remplace_point = (s) => {
    if (s) {
      var t = s.toString();
      return t.replace('.',',');
    }
  }

  const paginatedLignes = [];
  const nombre_articles_par_page = 9

  if (lignesDocument.length > 0) {
    const firstPageItems = lignesDocument.slice(0, nombre_articles_par_page);
    paginatedLignes.push(firstPageItems);

    let startIndex = nombre_articles_par_page;
    while (startIndex < lignesDocument.length) {
      const nextItems = lignesDocument.slice(startIndex, startIndex + nombre_articles_par_page);
      paginatedLignes.push(nextItems);
      startIndex += nombre_articles_par_page;
    }
  }

  console.log(paginatedLignes);


  return (
    <Document>
      {paginatedLignes.map((lignesPage, pageIndex) => (
        <Page size="A4" key={pageIndex}>
          {/* En-tête et infos à afficher sur chaque page */}
          <View style={styles.pageBackgroundContainer}>
            <Image src={background} style={styles.imageBackground} />
          </View>
          <View style={styles.container}>
            <Image src={logo} style={styles.imageLogo}/>
            <Text style={styles.text_logo}>{detailsEtab.nom ? detailsEtab.nom.toUpperCase() : 'N/A'}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.societe}>{detailsEtab.nom ? detailsEtab.nom.toUpperCase() : 'N/A'}<Br/>{detailsEtab.rue1 ? detailsEtab.rue1.toUpperCase() : 'N/A'}<Br/>{detailsEtab.code_postal ? detailsEtab.code_postal.toUpperCase() + " " : "N/A" + " "}{detailsEtab.ville ? detailsEtab.ville.toUpperCase() : 'N/A'}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.numero_document}>N° Document</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.corps_numero_document}>OD{numero}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.numero_compte}>N° Compte</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.corps_numero_compte}>{detailsClient.cpt ? detailsClient.cpt : "N/A"}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.date}>Date</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.corps_date}>{enteteDocument.date_creation ? formatDate(enteteDocument.date_creation.split('T')[0]) : "N/A"}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.titre}>OFFRE de PRIX</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.affaire}>Affaire suivie par : </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.corps_affaire}>{enteteDocument.util_prenom + " " + enteteDocument.util_nom ? enteteDocument.util_prenom + " " + enteteDocument.util_nom : "N/A"}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.reference}>Vos références : </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.corps_reference}></Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.page}>Page </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.montant_1}>{remplace_point(montantHT)}</Text>
          </View>
          <View style={styles.tableauContainerBaseTVA}>
            <View style={[styles.ligneBaseTVA, { fontFamily: 'ArialBold' }]}>
            </View>
            {Object.keys(baseTVA).map((taux, idx) => (
              <View style={styles.ligneBaseTVA} key={idx}>
                {parseFloat(taux) > 0 && (
                  <>
                    <Text style={styles.colTitreBaseTVA}>{`TVA ${idx + 1} : ${remplace_point(taux)}`}</Text>
                    <Text style={styles.colDeviseBaseTVA}>EUR</Text>
                    <Text style={styles.colBaseTVA}>{remplace_point(montantTVA[taux].toFixed(2))}</Text>
                  </>
                )}
              </View>
            ))}
          </View>
          <View style={styles.tableauContainerBaseTVA2}>
            <View style={[styles.ligneBaseTVA2, { fontFamily: 'ArialBold' }]}>
            </View>
            {Object.keys(baseTVA).map((taux, idx) => (
              <View style={styles.ligneBaseTVA2} key={idx}>
                {parseFloat(taux) > 0 && (
                  <>
                    <Text style={styles.colTitreBaseTVA2}>{`TVA ${idx + 1} : ${remplace_point(taux)}`}</Text>
                    <Text style={styles.colBaseTVA2}>{remplace_point(baseTVA[taux].toFixed(2))}</Text>
                  </>
                )}
              </View>
            ))}
          </View>
          <View style={styles.container}>
            <Text style={styles.montant_total_3}>
              {remplace_point(montantTTC)}
            </Text>
          </View>
          <View style={styles.tableauContainer}>
            <View style={[styles.ligne, { fontFamily: 'ArialBold' }]}>
              <Text style={styles.colUniteHeader}>#</Text>
              <Text style={styles.colQteHeader}>Qté</Text>
              <Text style={styles.colUsHeader}>Us</Text>
              <Text style={styles.colLibelleHeader}>Code Article & Libellé</Text>
              <Text style={styles.colDelaiHeader}>Délai</Text>
              <Text style={styles.colPrixHeader}>P.U</Text>
              <Text style={styles.colMontantHeader}>Montant</Text>
            </View>

            {lignesPage.map((ligne, index) => {
              const paramText = [
                ligne.nom && `Nom : ${ligne.nom}`,
                ligne.lib02 && `Spécificités : ${ligne.lib02}`,
                ligne.superficie && `Superficie : ${ligne.superficie}`,
                ligne.piece && `Nombre de pièce : ${ligne.piece}`,
                ligne.qte_exp && `Nombre de passage : ${ligne.qte_exp}`
              ].filter(Boolean).join(' | ');

              return (
                <View style={styles.ligne} key={index}>
                  <Text style={styles.colUnite}>{pageIndex * ARTICLES_PAR_PAGE + index + 1}</Text>
                  <Text style={styles.colQte}>{ligne.qte_exp}</Text>
                  <Text style={styles.colUs}>Un</Text>
                  <Text style={styles.colLibelle}>
                    {/*{ligne.code_article} - {ligne.lib01 || ''}*/}
                    {ligne.lib01 || ''}
                    <Br />
                    <View style={styles.paramRow}>
                      <Text style={styles.paramText}>{paramText}</Text>
                    </View>
                  </Text>
                  <Text style={styles.colDelai}>
                    {ligne.delai ? formatDate(ligne.delai.split('T')[0]) : 'N/A'}
                  </Text>
                  <Text style={styles.colPrix}>
                    {remplace_point((ligne.valeur / ligne.qte_exp).toFixed(2))}
                  </Text>
                  <Text style={styles.colMontant}>
                    {remplace_point(ligne.valeur)}
                  </Text>
                </View>
              );
            })}

            {/* Ajout des deux lignes spéciales à la dernière page uniquement */}
            {pageIndex === paginatedLignes.length - 1 && (
              <>
                {montantTransport > 0 && (
                  <View style={styles.ligne}>
                    <Text style={styles.colUnite}></Text>
                    <Text style={styles.colQte}></Text>
                    <Text style={styles.colUs}></Text>
                    <Text style={styles.colLibelle}>Transport</Text>
                    <Text style={styles.colDelai}></Text>
                    <Text style={styles.colPrix}></Text>
                    <Text style={styles.colMontant}>
                      {remplace_point(montantTransport.toFixed(2))}
                    </Text>
                  </View>
                )}

                {montantProduitMateriel > 0 && (
                  <View style={styles.ligne}>
                    <Text style={styles.colUnite}></Text>
                    <Text style={styles.colQte}></Text>
                    <Text style={styles.colUs}></Text>
                    <Text style={styles.colLibelle}>Produits / Matériels</Text>
                    <Text style={styles.colDelai}></Text>
                    <Text style={styles.colPrix}></Text>
                    <Text style={styles.colMontant}>
                      {remplace_point(montantProduitMateriel.toFixed(2))}
                    </Text>
                  </View>
                )}
              </>
            )}
          </View>
          {/* Pied de page et totaux UNIQUEMENT sur la dernière page */}
          {pageIndex === paginatedLignes.length - 1 && (
            <>
              {/* ...tous tes blocs totaux, TVA, infos client, etc. ... */}
              <View style={styles.tableauContainerBaseTVA}>
                <View style={[styles.ligneBaseTVA, { fontFamily: 'ArialBold' }]}></View>
                {Object.keys(baseTVA).map((taux, idx) => (
                  <View style={styles.ligneBaseTVA} key={idx}>
                    {parseFloat(taux) > 0 && (
                      <>
                        <Text style={styles.colTitreBaseTVA}>{`TVA ${idx + 1} : ${remplace_point(taux)}`}</Text>
                        <Text style={styles.colDeviseBaseTVA}>EUR</Text>
                        <Text style={styles.colBaseTVA}>{remplace_point(montantTVA[taux].toFixed(2))}</Text>
                      </>
                    )}
                  </View>
                ))}
              </View>
            </>
          )}

          {/* Numéro de page */}
          <View style={styles.container}>
            <Text style={styles.page}>{`Page ${pageIndex + 1} / ${paginatedLignes.length}`}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.libelle_livraison}>Livraison à :</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.data_client}>{adresse_client(detailsClient)}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.data_client_2}>{adresse_client(detailsClient)}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.data_client_3}>Tél : 03 82 25 88 93                                    TVA : FR27775615594<Br/>Fax : 03 82 25 25 41                                   Siret : 77561559400378</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.base}>Base soumise à TVA :</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.montant_ht}>Montant HT</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.unite_eur_1}>EUR</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.total}>TOTAL</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.unite_eur_3}>EUR</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.reglement}>REGL : Virement à 30  jours Fin de Mois</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.dir}>Direction</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.service}>Service</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.VISA1}>VISA</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.VISA2}>VISA</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.banque}><Br/></Text>
          </View>
        </Page>
      ))}
    </Document>
  );
}

export default App;